import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ApiService} from '../../../@core/service/api.service';
import {
  EProjectDevelopmentDisplay,
  EProjectQuantityUnitDisplay,
  ProjectListModel, ProjectModel,
} from '../../../@models';
import {LocalDataSource} from 'ng2-smart-table';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'ngx-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss'],
})
export class ProjectListComponent implements OnInit, OnDestroy {
  settings = {
    actions: false,
    columns: {
      sales: {
        title: 'Sales',
        width: '10rem',
      },
      customer: {
        title: 'Customer',
        width: '10rem',
      },
      city: {
        title: 'City',
        width: '7.5rem',
      },
      country: {
        title: 'Country',
        width: '7.5rem',
      },
      region: {
        title: 'Region',
        width: '10rem',
      },
      businessUnit: {
        title: 'BU',
        width: '10rem',
      },
      name: {
        title: 'Project',
        width: '10rem',
      },
      material: {
        title: 'Equipment',
        width: '7.5rem',
      },
      baseProduct: {
        title: 'Base Product',
        width: '10rem',
        valuePrepareFunction: (val) => val ? `${val.code} - ${val.name} [${val.trial}]` : '',
      },
      unit: {
        title: 'Unit',
        width: '5rem',
      },
      quantity: {
        title: 'Quantity',
        width: '5rem',
      },
      price: {
        title: 'Price',
        width: '5rem',
      },
      currency: {
        title: 'Currency',
        width: '5rem',
      },
      probability: {
        title: 'Probability',
        width: '5rem',
      },
      share: {
        title: 'Share',
        width: '5rem',
      },
      equipmentValue: {
        title: 'Total Potential',
        width: '5rem',
      },
      nipponrikaPotential: {
        title: 'NR Potential',
        width: '5rem',
      },
      nipponrikaValue: {
        title: 'NR Value',
        width: '5rem',
      },
      offerDate: {
        title: 'Offer date',
        width: '5rem',
      },
      offerTitle: {
        title: 'Offer title',
        width: '10rem',
      },
      orderDate: {
        title: 'Order date',
        width: '5rem',
      },
      orderTitle: {
        title: 'Order title',
        width: '10rem',
      },
      lastActivity: {
        title: 'Last activity',
        width: '5rem',
      },
      lastActivityType: {
        title: 'Last activity type',
        width: '5rem',
      },
      information: {
        title: 'Information',
        width: '20rem',
      },
      status: {
        title: 'Status',
        width: '5rem',
      },
      type: {
        title: 'Type',
        width: '5rem',
      },
      development: {
        title: 'Development',
        width: '10rem',
      },
      connectedProjects: {
        title: 'Connected Projects',
        width: '10rem',
      },
      connectedValue: {
        title: 'Total Value',
        width: '5rem',
      },
    },
    filter: {
      inputClass: 'filter',
    },
  };

  private subscription: Subscription;

  projects: ProjectListModel[];

  source: LocalDataSource;

  constructor(private api: ApiService) { }

  ngOnInit() {
    this.source = new LocalDataSource();

    this.subscription = this.api.projectList().subscribe(values => {
      this.projects = values.filter(f => f.active); // .filter(x => x.lastActivity != null && x.lastActivity.length > 0);
      this.projects.forEach(x => {
        x.probability = isNaN(x.probability as number) ? '' : `${x.probability as number * 100} %`;
        x.share = isNaN(x.share as number) ? '' : `${x.share as number * 100} %`;
        x.nipponrikaValue = (x.nipponrikaValue || '').toLocaleString('en-US');
        x.nipponrikaPotential = (x.nipponrikaPotential || '').toLocaleString('en-US');
        x.development = x.development ? EProjectDevelopmentDisplay[x.development].name : '';
        x.unit = x.unit ? EProjectQuantityUnitDisplay[x.unit].name : '';
        x.offerDate = x.offerDate ? new DatePipe('en-US').transform(x.offerDate, 'MMM dd, yyyy') : '';
        x.orderDate = x.orderDate ? new DatePipe('en-US').transform(x.offerDate, 'MMM dd, yyyy') : '';
        x.lastActivity = x.lastActivity ? new DatePipe('en-US').transform(x.offerDate, 'MMM dd, yyyy') : '';
        x.connectedValue = (
          (x.equipmentValue as number) +
          (x.connectedProjects
            ? (x.connectedProjects as ProjectModel[])
              .map(y => y.potential || 0).reduce((a, b) => a + b, 0)
            : 0)).toLocaleString('en-US');
        x.equipmentValue = (x.equipmentValue || '').toLocaleString('en-US');
        x.connectedProjects = x.connectedProjects ?
          (x.connectedProjects as ProjectModel[]).map(y => y.name).join(', ') : '';
      });
      this.source.load(this.projects);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  downloadXlsx() {
    this.api.downloadProjectlist();
  }
}
